// Mock data for MasterPlan band website

export const bandMembers = [
  {
    id: 1,
    name: 'Bibin',
    role: 'Vocals',
    caricature: '/images/band-members/Bibin.jpg',
    photo: '',
    bio: 'Lead vocalist with powerful stage presence'
  },
  {
    id: 2,
    name: 'Steo',
    role: 'Vocals',
    caricature: '/images/band-members/Steo.jpg',
    photo: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=400',
    bio: 'Dynamic vocalist with incredible range'
  },
  {
    id: 3,
    name: 'Mini',
    role: 'Vocals',
    caricature: '/images/band-members/Mini.jpg',
    photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400',
    bio: 'Soulful voice that touches hearts'
  },
  {
    id: 4,
    name: 'Bhavana',
    role: 'Vocals',
    caricature: '/images/band-members/Bhavana.jpg',
    photo: '',
    bio: 'Energetic performer with captivating vocals'
  },
  {
    id: 5,
    name: 'Nigel',
    role: 'Vocals',
    caricature: '/images/band-members/Nigel.jpg',
    photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400',
    bio: 'Passionate vocalist with heartfelt delivery'
  },
  {
    id: 6,
    name: 'George',
    role: 'Keyboards',
    caricature: '/images/band-members/George.jpg',
    photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400',
    bio: 'Master keyboardist creating atmospheric soundscapes'
  },
  {
    id: 7,
    name: 'Sony',
    role: 'Keyboards',
    caricature: '/images/band-members/Sony.jpg',
    photo: '/images/band-members/SonyOG.jpg',
    bio: 'Skilled keyboardist with perfect harmony'
  },
  {
    id: 8,
    name: 'Sherwell',
    role: 'Guitars',
    caricature: '/images/band-members/Sherwell.jpg',
    photo: '',
    bio: 'Guitar virtuoso with electrifying performances'
  },
  {
    id: 9,
    name: 'Edwin',
    role: 'Bass',
    caricature: '/images/band-members/Edwin.jpg',
    photo: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400',
    bio: 'Groove master laying down solid foundations'
  },
  {
    id: 10,
    name: 'Neil',
    role: 'Drums',
    caricature: '/images/band-members/Neil.jpg',
    photo: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400',
    bio: 'Powerhouse drummer keeping the rhythm alive'
  },
  {
    id: 11,
    name: 'Diago',
    role: 'Guitars',
    caricature: '/images/band-members/Diago.jpg',
    photo: 'https://images.unsplash.com/photo-1511367461989-f85a21fda167?w=400',
    bio: 'Passionate guitarist with incredible technique'
  }
];

export const highlights = [
  {
    id: 1,
    title: 'Youth Arise International',
    description: 'Performed at the International Youth Gathering in Rio de Janeiro, Brazil (2013)',
    year: '2013',
    icon: 'Globe'
  },
  {
    id: 2,
    title: 'WYD Krakow Official Hymn',
    description: 'Released cover of World Youth Day Krakow official hymn',
    year: '2016',
    icon: 'Music'
  },
  {
    id: 3,
    title: 'Diocesan World Youth Days',
    description: 'Regular performers since 2009 at youth gatherings across the Middle East',
    year: '2009-Present',
    icon: 'Calendar'
  },
  {
    id: 4,
    title: 'Catholic Youth Conference',
    description: 'Official band for Catholic Youth Conference of Arabia',
    year: 'Ongoing',
    icon: 'Users'
  },
  {
    id: 5,
    title: '200+ Main Stages',
    description: 'Performed on over 200 major stages across the Middle East',
    year: 'Since 2009',
    icon: 'Trophy'
  },
  {
    id: 6,
    title: 'Thousands Inspired',
    description: 'Touched the hearts of thousands of young people through worship',
    year: '15+ Years',
    icon: 'Heart'
  }
];

export const heroSlides = [
  {
    id: 1,
    title: 'MasterPlan',
    description: 'Serving God through Music',
    image: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=1920&q=80',
    bgColor: '#1A1A2E',
    textColor: '#00FF88'
  },
  {
    id: 2,
    title: 'Live Worship',
    description: '15+ Years of Powerful Performances',
    image: 'https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?w=1920&q=80',
    bgColor: '#6B1B9A',
    textColor: '#FFFFFF'
  },
  {
    id: 3,
    title: 'Youth Events',
    description: 'Inspiring the Next Generation',
    image: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=1920&q=80',
    bgColor: '#0A0A0A',
    textColor: '#1DB954'
  }
];

export const galleryImages = [
  { id: 1, url: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=800', type: 'photo', title: 'Live Performance 1' },
  { id: 2, url: 'https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?w=800', type: 'photo', title: 'Live Performance 2' },
  { id: 3, url: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=800', type: 'photo', title: 'Youth Event 1' },
  { id: 4, url: 'https://images.unsplash.com/photo-1524368535928-5b5e00ddc76b?w=800', type: 'photo', title: 'Worship Night' },
  { id: 5, url: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=800', type: 'photo', title: 'Stage Setup' },
  { id: 6, url: 'https://images.unsplash.com/photo-1506157786151-b8491531f063?w=800', type: 'photo', title: 'Conference Performance' },
  { id: 7, url: 'https://images.unsplash.com/photo-1511735111819-9a3f7709049c?w=800', type: 'photo', title: 'Band Rehearsal' },
  { id: 8, url: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=800', type: 'photo', title: 'Concert Night' }
];

export const mediaVideos = [
  {
    id: 1,
    title: 'MasterPlan Live at Allgorhythm Music Festival, Kochi India',
    thumbnail: 'https://img.youtube.com/vi/7YkEz8Fth_s/hqdefault.jpg',
    videoUrl: 'https://youtu.be/7YkEz8Fth_s',
    duration: '4:32',
    views: '12K'
  },
  {
    id: 2,
    title: 'Here I am, The Servant of The Lord - WYD Panama 2019 English Dance Version',
    thumbnail: 'https://img.youtube.com/vi/llDSy8yW6Bg/hqdefault.jpg',
    videoUrl: 'https://youtu.be/llDSy8yW6Bg',
    duration: '6:45',
    views: '8.5K'
  },
  {
    id: 3,
    title: "My Soul Proclaims the Lord my God (Magnificat / Mary's Song)",
    thumbnail: 'https://img.youtube.com/vi/gZbFlMc_qgk/hqdefault.jpg',
    videoUrl: 'https://youtu.be/gZbFlMc_qgk',
    duration: '5:15',
    views: '15K'
  },
  {
    id: 4,
    title: 'Haste in the Air - World Youth Day Lisbon 2023 (EDM Version)',
    thumbnail: 'https://img.youtube.com/vi/p7-DXmVePrI/hqdefault.jpg',
    videoUrl: 'https://youtu.be/p7-DXmVePrI',
    duration: '3:20',
    views: '6K'
  }
];

export const musicTracks = [
  {
    id: 1,
    title: 'Blessed Assurance',
    album: 'Live at Dubai',
    duration: '4:45',
    coverArt: 'https://images.unsplash.com/photo-1619983081563-430f63602796?w=400',
    audioUrl:"https://open.spotify.com/track/5DIczTSAjIP2TwXU94L5yA?si=0ee9bbb0fa6b4ea2"
  },
  {
    id: 2,
    title: 'How Great Thou Art',
    album: 'Youth Conference 2023',
    duration: '5:20',
    coverArt: 'https://images.unsplash.com/photo-1507838153414-b4b713384a76?w=400',
    audioUrl:"https://open.spotify.com/track/6E7MM69A8FMoL8YerXCC9j?si=0922da7b024340de"
  },
  {
    id: 3,
    title: 'Amazing Grace',
    album: 'Worship Sessions',
    duration: '6:10',
    coverArt: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=400',
    audioUrl:"https://open.spotify.com/track/5DIczTSAjIP2TwXU94L5yA?si=ee272d91c00c42aa"
  },
  {
    id: 4,
    title: 'In Christ Alone',
    album: 'Live Recordings',
    duration: '4:30',
    coverArt: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=400',
    audioUrl:"https://open.spotify.com/track/7uL0BDHtMZHX7AeL32zk0Q?si=74e1a36852c547bf"
  },
  {
    id: 5,
    title: 'In Christ Alone',
    album: 'Live Recordings',
    duration: '4:30',
    coverArt: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=400',
    audioUrl:"https://open.spotify.com/track/7uL0BDHtMZHX7AeL32zk0Q?si=dd180d7ff5a3430f"
  },
  {
    id: 6,
    title: 'In Christ Alone',
    album: 'Live Recordings',
    duration: '4:30',
    coverArt: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=400',
    audioUrl:"https://open.spotify.com/track/6GRISJfwX4OmayeAEZzEiW?si=18b1844cf7874f90"
  },
  {
    id: 7,
    title: 'In Christ Alone',
    album: 'Live Recordings',
    duration: '4:30',
    coverArt: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=400',
    audioUrl:"https://open.spotify.com/track/3uRLhILUpwuqucRqkkPELj?si=e5f8e7245e504fae"
  },
  {
    id: 8,
    title: 'In Christ Alone',
    album: 'Live Recordings',
    duration: '4:30',
    coverArt: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=400',
    audioUrl:"https://open.spotify.com/track/0tf2MQqUpsQzlcFAZV3Q5t?si=5d5cd5ce7bbd4776"
  }
];

export const stats = [
  { label: '200+', description: 'Main Stages' },
  { label: '1000s', description: 'Young People Inspired' },
  { label: 'Since 2009', description: 'Years of Excellence' },
  { label: '11', description: 'Talented Members' }
];
